module.exports = __webpack_public_path__ + "img/fd_hold.e310696d.png";